<template>
  <div class="top-nav" :style="{'padding-left': this.$store.state.core.maxMenuWidth,'transition': 'all 0.3s ease'}">
    <div class="site-title">
      <!-- <span> {{title}}</span> -->
      <!-- <i-switch v-model="theme" @on-change="changeTheme" true-value="dark" false-value="light">
                <span slot="open">黑</span>
                <span slot="close">白</span>
      </i-switch>-->
      <span>{{headtitle}}</span>
      <core-globalsearch class="site-input" style="width: 251px;"></core-globalsearch>
      <!-- <div class="site-input"><Input icon="ios-search" placeholder="请输入搜索内容" style="width: 300px;" /></div> -->
    </div>
    <!-- 铃铛 -->
    <core-remind style="margin-right:30px;" />
    <div class="top-menu">
      <core-userprofile />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentMenu: {}, //当前菜单
      submenu: [], //子菜单
      menu: {},
      onlysubmenu: "",
    }
  },
  components: {},
  inject: ["getmoduleTitle"],
  computed: {
    headtitle() {
      return this.getmoduleTitle(this.$route)
      // return this.$parent.$parent.moduleTitle;
    },
  },
  mounted() {},
  methods: {},
}
</script>
<style scoped>
.top-nav {
  height: 100%;
  padding-left: 260px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.site-title {
  display: flex;
  font-size: 20px;
  font-weight: bold;
  justify-content: space-between;
  margin-left: 20px;
  flex: 1;
}
.site-input {
  margin-right: 35px;
}
.top-menu {
  display: flex;
  margin-right: 30px;
}
/* 白色主题样式 */
.light .top-nav {
  background: #ffffff !important;
}

/* 黑色主题样式 */
.dark .top-nav {
  background: #404954 !important;
}

/* 蓝色主题样式 */
.blue .top-nav {
  background: #ffffff !important;
}
</style>